<script setup>
import { onMounted, onUnmounted } from 'vue'
import { installGoogleAnalytics } from '../utils/googleAnalytics'
import axios from 'axios'
const loadSettings = () => axios.get(`${import.meta.env.VITE_API_URL || ''}/api/settings/public`)
let disposed = false
onMounted(async () => {
  try {
    const { data } = await loadSettings()
    if (!disposed) installGoogleAnalytics(data?.googleAnalyticsCode || data?.google_analytics || '')
  } catch { /* Analytics must never block the application. */ }
})
onUnmounted(() => { disposed = true })
</script>
<template><!-- Standard Google tag; no cookie-settings dependency. --></template>
